import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'cx_foundations-topic_csat-click';

/**
 * Add csat events for contact us flow, as long as the logged-in user, select `is this helpful`
 */
export function trackCxFoundationsTopicCsatClick(
  TopicId: string,
  CSATResult2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { TopicId, CSATResult2 },
  });
}
